// Singleton LIFF initialization and utilities
import { CFG } from '../config/env';

let initPromise = null;

export async function initLiffOnce() {
  if (typeof window === 'undefined') return; // Guard against SSR
  if (initPromise) return initPromise;

  initPromise = (async () => {
    try {
      const { default: liff } = await import('@line/liff'); // Dynamic import
      const liffId = CFG.LIFF_ID;
      
      if (!liffId) throw new Error('Missing LIFF_ID from environment');

      await liff.init({ liffId });
      
      // Wait for liff.ready if available
      if (typeof liff.ready === 'object' && liff.ready instanceof Promise) {
        await liff.ready;
      }
      
      console.log('LIFF initialized successfully');
    } catch (error) {
      console.error('LIFF initialization failed:', error);
      throw error;
    }
  })();

  return initPromise;
}

export async function getIdTokenSafe() {
  try {
    await initLiffOnce();
    const { default: liff } = await import('@line/liff');
    
    if (!liff.isLoggedIn()) return null;
    return liff.getIDToken() || null;
  } catch (error) {
    console.error('Failed to get ID token:', error);
    return null;
  }
}

export async function ensureLoggedIn(redirectUri) {
  try {
    await initLiffOnce();
    const { default: liff } = await import('@line/liff');
    
    if (!liff.isLoggedIn()) {
      liff.login({ 
        redirectUri,
        scope: CFG.LIFF_SCOPE.split(' ')
      });
      return true; // Will redirect out
    }
    return false;
  } catch (error) {
    console.error('Failed to ensure logged in:', error);
    throw error;
  }
}

export async function getUserProfile() {
  try {
    await initLiffOnce();
    const { default: liff } = await import('@line/liff');
    
    if (!liff.isLoggedIn()) return null;
    return await liff.getProfile();
  } catch (error) {
    console.error('Failed to get user profile:', error);
    return null;
  }
}

export async function logoutLiff() {
  try {
    await initLiffOnce();
    const { default: liff } = await import('@line/liff');
    
    if (liff.isLoggedIn()) {
      liff.logout();
    }
  } catch (error) {
    console.error('Failed to logout:', error);
  }
}